
export const SET_MSG = 'DEPEDENTE_MSG';
export const SET_EDITAR = 'DEPEDENTE_EDITAR';
export const SET_LISTA = 'LISTA_EDITAR';